var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("Похоже, эта страница скрыта за горизонтом.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Вернуться на главную")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }